import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import PaymentMethodCard from "./PaymentMethodCard";
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import { getBalanceDisplay } from 'utils/balanceColor';
import { hasMinimumLaunchBalance } from 'utils/businessBalance';
import { saveAutoReloadPreference } from 'utils/businessAutoReload';
import { fetchBusiness } from 'modules/Business/actions';
import { useAutoReloadPreference } from 'modules/Business/components/AutoReloadPreference';
// import SetReload from "../../../../modules/Credits/components/SetReload";
// import AddPromo from "../../../../modules/Credits/components/AddPromo";
import OfferSaveActions from '../OfferSaveActions';
import WizardBackButton from '../WizardBackButton';

const OfferFund = ({
  values,
  business,
  onComplete,
  back,
  onSave,
  onUpdate,
  saveButtonLabel,
  isEditingActive,
}) => {
  const [updatedBusiness, setUpdatedBusiness] = useState(business);
  const [cardError, setCardError] = useState(false);
  const [isFunded, setIsFunded] = useState(false);
  const [isFunding, setIsFunding] = useState(false);
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const business2 = useSelector(state => state.business)
  const autoReloadPreference = useAutoReloadPreference(business2)
  useEffect(() => {
    setIsFunded(
      hasMinimumLaunchBalance(business2.accountBalance, business2)
    );
  }, [business2]);

  const addBalanceRef = useRef();

  useEffect(() => {
    const cardData = values.paymentUpdated?.card;
  
    if (cardData && cardData.brand && cardData.last4) {
      setUpdatedBusiness((prev) => ({
        ...prev,
        card: cardData,
      }));
      setCardError(false);
    } else {
      setCardError(true);
    }
  }, [values.paymentUpdated]);
  

  const handleSubmit = async (data) => {
    if (!updatedBusiness.card) {
      setCardError(true);
      enqueueSnackbar('Add a payment card before funding or launching this offer.', {
        variant: 'warning',
      });
      return;
    }

    // if (!isFunded) {
    //   // Trigger fund flow (show popup or redirect user)
    //   enqueueSnackbar("please add funds to the account to use your promo code.", {autoHideDuration: 3_000, variant: 'success'})
    //   return;
    // }

    if (!isFunded && addBalanceRef.current) {
      if (addBalanceRef.current.requiresPaymentReview()) return;
      setIsFunding(true);
      try {
        await addBalanceRef.current.triggerFund();
      } finally {
        setIsFunding(false);
      }
      return;
    }

    if (isFunded) {
      try {
        await saveAutoReloadPreference(
          business2.businessId,
          autoReloadPreference.reloadAmount
        );
        await dispatch(fetchBusiness(business2.businessId, true));
      } catch (e) {
        enqueueSnackbar(
          'Auto reload could not be updated. Review the setting and try again.',
          { variant: 'error' }
        );
        return;
      }
      onComplete(data);
    }
  };

  return (
    <Box>
      {cardError && !updatedBusiness.card && (
        <Typography color="error" mb={2}>
          Add a payment card before funding or launching this offer.
        </Typography>
      )}
  
      {/* Current Payment Method Card */}
      {updatedBusiness.card ? (
        <PaymentMethodCard
          business={{
            ...updatedBusiness,
            businessId: business2.businessId,
            paymentRules: business2.paymentRules,
          }}
          addBalanceRef={addBalanceRef}
          autoReloadPreference={autoReloadPreference}
        />
      ) : (
        <Box mb={3}>
          <Typography variant="body1" color="textSecondary">
            No payment method available
          </Typography>
          <Button 
            variant="outlined" 
            onClick={back}
            sx={{ mt: 2 }}
          >
            Add payment card
          </Button>
        </Box>
      )}

      {/* Buttons Area */}
      <Box mt={2} mb={1} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
        <OfferSaveActions
          onUpdate={isEditingActive && !isFunded ? onUpdate : undefined}
          onSave={() => onSave({})}
          saveButtonLabel={saveButtonLabel}
        />
  
        <Box mt={1} display="flex" alignItems="center" gap={2}>
          {/* Balance Text First */}
          {(() => {
  try {
    const balanceDisplay = getBalanceDisplay(
      business2.accountBalance,
      'Account balance:',
      business2
    );
    return (
      <Typography variant="body2" color={balanceDisplay.color}>
        {balanceDisplay.text}
      </Typography>
    );
  } catch (error) {
    return (
      <Typography variant="body2" color="error">
        Unable to display account balance. Please check your account settings.
      </Typography>
    );
  }
})()}
  
          {/* Then Back button */}
          <WizardBackButton onClick={back} />
  
          {/* Then Fund button */}
          <Button
            color="primary"
            onClick={handleSubmit}
            variant="contained"
            disabled={isFunding || (isFunded && !autoReloadPreference.isValid)}
          >
            {isFunding
              ? "Adding funds…"
              : isFunded
                ? (isEditingActive ? "Update offer" : "Launch offer")
                : "Fund"}
          </Button>
        </Box>
      </Box>
  
      <Box display="flex" alignItems="center">
        {/* Future space if needed */}
      </Box>
  
    </Box>
  );
  
  
};

export default OfferFund;
